import findLastKey from 'lodash/findLastKey';
import get from 'lodash/get';

import {
  SKIP_BASKET_RESPONSE,
  UNSKIP_BASKET_RESPONSE,
  ADD_BASKET_RESPONSE,
  UPDATE_BASKET_ADDRESS_RESPONSE,
  UPDATE_BASKET_RESPONSE,
  UNDONATE_BASKET_RESPONSE,
  DONATE_BASKET_RESPONSE,
  GET_BASKET_RESPONSE,
  GET_BASKET_SUMMARIES_RESPONSE,
  GET_TRACKING_RESPONSE,
  UNSKIP_BASKET_ERROR,
} from 'actions/baskets';
import { EMPTY_ARRAY } from 'lib/constants';
import { BASKET_SUMMARY_V3_RESPONSE } from 'lib/constants/v3Actions';

const initialState = {};

const initializeBaskets = (state, baskets) => {
  const basketHash = baskets.reduce(
    (hash, basket) => ({
      ...hash,
      [basket.menu.slug]: {
        ...basket,
        meals: [],
      },
    }),
    {}
  );

  return {
    ...basketHash,
    ...state,
  };
};

const basketSuccess = (state, menuSlug, basket) => {
  const existingBasket = state[menuSlug];
  return {
    ...state,
    [menuSlug]: { ...existingBasket, ...basket },
  };
};

const addTrackingLink = (state, action) => {
  const trackingResponse = action.response.tracking;
  const menuSlug = action.params.menuSlug;
  const trackingState = {
    ...state[menuSlug],
    newTrackingLink: trackingResponse ? trackingResponse.trackingLink : null,
  };

  return {
    ...state,
    [menuSlug]: trackingState,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BASKET_SUMMARIES_RESPONSE:
      return initializeBaskets(state, action.response.weeklyBaskets);
    case UNSKIP_BASKET_ERROR:
      return {
        ...state,
        [action.params.menuSlug]: {
          ...state[action.params.menuSlug],
          error: action.response.body,
        },
      };
    case SKIP_BASKET_RESPONSE:
    case UNSKIP_BASKET_RESPONSE:
    case UNDONATE_BASKET_RESPONSE:
    case UPDATE_BASKET_ADDRESS_RESPONSE:
    case GET_BASKET_RESPONSE:
    case DONATE_BASKET_RESPONSE:
      return basketSuccess(state, action.params.menuSlug, action.response.weeklyBasket);
    case ADD_BASKET_RESPONSE:
    case UPDATE_BASKET_RESPONSE:
    case BASKET_SUMMARY_V3_RESPONSE:
      return basketSuccess(
        state,
        action.response.weeklyBasket.menu.slug,
        action.response.weeklyBasket
      );
    case GET_TRACKING_RESPONSE:
      return addTrackingLink(state, action);
    default:
      return state;
  }
};

const EMPTY_BASKET = Object.freeze({ meals: EMPTY_ARRAY });
export const selectBasket = (state, menuSlug) => get(state, menuSlug, EMPTY_BASKET);
export const selectMealsForBasket = (state, menuSlug) =>
  get(selectBasket(state, menuSlug), 'meals') || EMPTY_ARRAY;

export const selectLastOrderableMenuSlug = state => findLastKey(state);
